import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {bbDoesCustomerHaveAccessToModule,
    bbGetModulePropertyFromIdOrName,
    BBModuleIcon,
    mapObject
} from "../../../../util/bbHelpers";
import {fetchCustomers, fetchHumans} from "../../../../actions";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import BBDataTable from "../../tables/BBDataTable";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";

// const useStyles = makeStyles((theme) => ({
//     button: {
//         margin: theme.spacing(1),
//     },
// }));

const TableContainer = (props) => {

    const {customerId} = props;

  // const [activeTab, setActiveTab] = useState('1');

  // const classes = useStyles();
  // const handleChangeTab = (event, newTab) => {
  //   setActiveTab(newTab);
  // }

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, loadingHumans, loadingHumansError} = useSelector(({customer}) => customer);
  // const {authUser} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customers[customerId] ? customers[customerId] : null : null;
  //from the customer, pull the human data if it exists
  const humans = customer ? customer.humans ? customer.humans : null : null;

  useEffect(() => {
    // console.group("Humans Table for customerId: ", customerId, " customer: ", customer, " humans: ", humans)
    // console.log("HumansTable here is the customers in the store", customers)
    if (customers == null && !loadingCustomers) {
      // console.log("Customers is empty, fetching.")
      dispatch(fetchCustomers());
    }
      if (customer == null) {
          // console.log("No customer with customerId", customerId," was found.")
      } else if (customer && humans == null && !loadingHumans) {
          // console.log("humans is empty, fetching humans for customerId = ", customer.CustomerId);
          dispatch(fetchHumans({
              customerId: customer.CustomerId
          }));
      }
    // console.groupEnd()
  }, [customers, customerId, humans, dispatch, loadingCustomers, loadingHumans, customer]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <span className={"tourStepAllHumansTable"}>
        All Human Targets <Tooltip title={"Human Targets include people or accounts in the company that might be vulnerable to social engineering attacks, such as phishing."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </span>;

  const userTableHeadings = [
      // https://material-ui.com/components/data-grid/columns/

      // { field: 'id', headerName: 'ID', width: 70 },
      // { field: 'firstName', headerName: 'First name', width: 130 },
      // { field: 'lastName', headerName: 'Last name', width: 130 },
      // {
      //     field: 'age',
      //     headerName: 'Age',
      //     type: 'number',
      //     width: 90,
      // },
      // {
      //     field: 'fullName',
      //     headerName: 'Full name',
      //     description: 'This column has a value getter and is not sortable.',
      //     sortable: false,
      //     width: 160,
      //     valueGetter: (params) =>
      //         `${params.getValue('firstName') || ''} ${params.getValue('lastName') || ''}`,
      // },

      // { field: 'id', headerName: 'ID', hide: true, flex : 2, sortable: true, type: 'string', },
      { field: 'fullName', headerName: 'Full Name', hide: true, flex : 2, sortable: true, type: 'string',
          valueGetter: (params) =>
              `${params.row.first || ''} ${params.row.last || ''}`, renderCell: renderCellExpand},
      { field: 'first', headerName: 'First Name', hide: false, sortable: true, type: 'string', flex : 1, renderCell: renderCellExpand},
      { field: 'last', headerName: 'Last Name', hide: false, sortable: true, type: 'string', flex : 1, renderCell: renderCellExpand},
      { field: 'position', headerName: 'Position', sortable: true, type: 'string', flex : 2, renderCell: renderCellExpand},
      { field: 'email', headerName: 'Email', sortable: true, type: 'string',
          renderCell: (params) =>
              renderCellExpand (params, (
              params.value ? <code>{params.value}</code> : <code>None Detected</code>
          )), flex : 3},

  ];

    //peel the state data into a form the dataTable can read
  const tableData = humans ? mapObject(humans, (key, human) => {
    return (
        {
            id: human["Id"] ? human["Id"] : key,
            // icon: <BBIconHumanTarget/>,
            first: human["First Name"] ? human["First Name"] : "None detected.",
            last: human["Last Name"] ? human["Last Name"] : "None detected.",
            position: human["Position"] ? human["Position"] : "None detected.",
            // email: human["Email Address"] ? <code key={`${key}_humanTargets`}>{human["Email Address"]}</code> : "None detected.",
            email: human["Email Address"] ? human["Email Address"] : null,
        }
    )
  }) : null;

  const tableDataAsArray = () => {
      // console.log("Creating humansTableData as array from humanTableData ", tableData);
      let arr=[];
      for (let ob in tableData) {
          // console.log("ob is ", tableData[ob])
          arr.push(tableData[ob]);
      }
      // console.log("resulting array ", arr);
      return arr;
  }


  // if (humans && !loadingHumansError) {
    // console.log("HumansTable loading is finished here is the customers in the store", customers, "and table data", tableDataAsArray())
    return (
        <div>
                {(humans && !loadingHumansError && !loadingHumans) &&
                <BBDataTable
                    columns={userTableHeadings}
                    rows={ tableDataAsArray() }
                    // defaultPageSize={25}
                    title={title}
                    loading = {false}
                    progressValue={100}
                    bufferValue={100}
                    enableExport
                    requiresModule={"monitor"}
                    customer={customer}
                    topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                    defaultSortModel = {[
                        {
                            field: 'last',
                            sort: 'asc',
                        }

                    ]}
                />
                }
                {!(humans && !loadingHumansError && !loadingHumans) &&
                <BBDataTable
                    columns={userTableHeadings}
                    rows={[]}
                    title={title}
                    loading = {true}
                    progressValue={loadingHumansError ? 0 : loadingHumans ? 50 : 25}
                    bufferValue={loadingHumansError ? 0 : loadingHumans ? 75 : 50}
                />
                }
        </div>
    );


}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer;